import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApiHelperService } from '../../core/api-helper.service';
import { SubscriptionModel, SubscriptionStatus } from './subscription.model';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionService {

    constructor(private apiHelper: ApiHelperService) {}

    private options = { authenticate: true, setRoot: true };

    async put(sub: Partial<SubscriptionModel>): Promise<SubscriptionModel> {
        return this.apiHelper.apiCallSane(
            '/subscription',
            'PUT',
            this.apiHelper.getDefaultHeaders(),
            null,
            sub,
            this.options
        ).then((ps: Partial<SubscriptionModel>) => new SubscriptionModel(ps));
    }

    async updateSubscription(id: string, update: Partial<SubscriptionModel>): Promise<SubscriptionModel> {
        return this.apiHelper.apiCallSane(
            '/subscription',
            'PATCH',
            this.apiHelper.getDefaultHeaders(),
            { id },
            update,
            this.options
        ).then((ps: Partial<SubscriptionModel>) => new SubscriptionModel(ps));
    }

    get(sub: Partial<SubscriptionModel>): Promise<SubscriptionModel|undefined> {
        return this.apiHelper.apiCallSane(
            '/subscription',
            'GET',
            this.apiHelper.getDefaultHeaders(),
            sub,
            null,
            this.options
        ).then((ps: Partial<SubscriptionModel>) => ps == null ? null : new SubscriptionModel(ps));
    }

    async getSubscriptionById(id:string): Promise<SubscriptionModel> {
        return this.apiHelper.apiCallSane(
            '/subscription',
            'GET',
            this.apiHelper.getDefaultHeaders(),
            { id },
            null,
            this.options
        ).then((ps: Partial<SubscriptionModel>) => new SubscriptionModel(ps));
    }

    getAllSubscriptions(): Promise<SubscriptionModel[]> {
        const headers: HttpHeaders = this.apiHelper.getDefaultHeaders();
        return  this.apiHelper.apiCallSane('/subscriptions', 'GET', headers, null, null)
            .then((pss: Partial<SubscriptionModel>[]) => pss.map(ps => new SubscriptionModel(ps)));
    }

    /**
     * If null, remove final bill date
     * If today, bill and close,
     * If a day in the future, set up accordingly.
     */
    cancelSubscription(id: string, finalBillDate: Date = null): Promise<SubscriptionModel> {
        const headers: HttpHeaders = this.apiHelper.getDefaultHeaders();
        const patch: Partial<SubscriptionModel> = {
            status:  SubscriptionStatus.CANCELED,
            currentPeriodEnd: finalBillDate
        };
        return this.apiHelper.apiCallSane(
            '/subscription/cancel',
            'PUT',
            headers,
            { id },
            patch,
            this.options
        ).then((ps: Partial<SubscriptionModel>) => new SubscriptionModel(ps));
    }
}
